import { render, staticRenderFns } from "./purchase-msg.vue?vue&type=template&id=5ec7897e"
import script from "./purchase-msg.vue?vue&type=script&lang=js"
export * from "./purchase-msg.vue?vue&type=script&lang=js"
import style0 from "./purchase-msg.vue?vue&type=style&index=0&id=5ec7897e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports